export const scrollToHeader = (headerText: string, retries = 10) => {
  const editorElement = document.querySelector(".ProseMirror");
  if (!editorElement) {
    if (retries > 0) setTimeout(() => scrollToHeader(headerText, retries - 1), 1000);
    return;
  }

  const headings = editorElement.querySelectorAll("h1, h2");

  for (const heading of Array.from(headings)) {
    if (heading.textContent?.trim() === headerText.trim()) {
      heading.scrollIntoView({ behavior: "smooth", block: "start" });
      break;
    }
  }
};
